<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import download from '@/utils/download'
  let status = {0:"失败",1:"成功"};
  let type = {0:"真实",1:"模拟转真实"};
  let target = {p1:"p1",p2:"p2",p3:"p3",p4:"p4"};
  let creditTunnel2 = {WANGSHANG:"WANGSHANG",XIUPAI:"XIUPAI",XUNCHENG:"XUNCHENG",JUHE:"JUHE"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('txmis.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if( window.$t('txmis.bt.down') == clickName){
            //隐藏关键字段
            const param = Object.assign(JSON.parse(JSON.stringify(data)), {exportHide:true});
            download.exportExcel(URL.registervalidate.export,param,"开户验证记录");
        }else if(window.$t('txmis.bt.export') == clickName){
            const param = Object.assign(JSON.parse(JSON.stringify(data)), {});
            download.exportExcel(URL.registervalidate.export,param,"开户验证记录");
        }
      },
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('txmis.common.startTime'), field: 'startTime',type:5},
              { title: window.$t('txmis.common.endTime'), field: 'endTime',type:5},
              { title: window.$t('txmis.registervalidate.customerNo'), field: 'customerNo'},
              { title: window.$t('txmis.common.phone'), field: 'mobilePhone'},
              { title: window.$t('txmis.common.name'), field: 'chineseName'},
              { title: window.$t('txmis.registervalidate.registerType'), field: 'registerType',type:2,optionList:type},
              { title: window.$t('txmis.registervalidate.target'), field: 'target',type:2,optionList:target},
              { title: window.$t('txmis.registervalidate.creditTunnel2'), field: 'creditTunnel2',type:2,optionList:creditTunnel2},
              { title: window.$t('txmis.registervalidate.validateStatus2'), field: 'validateStatus2',type:2,optionList:status},
              { title: window.$t('txmis.registervalidate.validateStatus3'), field: 'validateStatus3',type:2,optionList:status},
              { title: window.$t('txmis.registervalidate.registerStatus'), field: 'registerStatus',type:2,optionList:status},
              {click: window.$t('txmis.bt.search')},
              {click: window.$t('txmis.bt.down')},
              {click: window.$t('txmis.bt.export')},

          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.registervalidate.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('txmis.registervalidate.customerNo'), field: 'customerNo'},
              { title: window.$t('txmis.common.phone'), field: 'mobilePhone'},
              { title: window.$t('txmis.common.name'), field: 'chineseName'},
              { title: window.$t('txmis.common.idNumber'), field: 'idNumber'},
              { title: window.$t('txmis.registervalidate.channel'), field: 'channel'},
              { title: window.$t('txmis.registervalidate.creditTunnel2'), field: 'creditTunnel2'},
              { title: window.$t('txmis.registervalidate.creditTunnel3'), field: 'creditTunnel3'},
              { title: window.$t('txmis.registervalidate.validateStatus2'), field: 'validateStatus2',render:(data,full)=>{
                      return status[data] || "";
                  }},
              { title: window.$t('txmis.registervalidate.validateStatus3'), field: 'validateStatus3',render:(data,full)=>{
                      return status[data] || "";
                  }},
              { title: window.$t('txmis.registervalidate.target'), field: 'target'},
              { title: window.$t('txmis.registervalidate.registerStatus'), field: 'registerStatus'},
              { title: window.$t('txmis.registervalidate.registerType'), field: 'registerType',render:(data,full)=>{
                      return type[data] || "";
                  }},
              { title: window.$t('txmis.common.createTime'), field: 'createTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('txmis.common.remark'), field: 'remark'},
              { title: window.$t('txmis.registervalidate.kycResult'), field: 'kycResult'},
              { title: window.$t('txmis.registervalidate.personMarkTunnel'), field: 'personMarkTunnel'},
              { title: window.$t('txmis.registervalidate.personMarkResult'), field: 'personMarkResult'},
              { title: window.$t('txmis.registervalidate.creditLoanTunnel'), field: 'creditLoanTunnel'},
              { title: window.$t('txmis.registervalidate.creditLoanResult'), field: 'creditLoanResult'},
          ]
        }
      }
    }
  }
</script>
